import { useState } from "react";
import Modal from "../../../UI/Modal/Modal";
import MoreSeatsRadioButton from "../MoreSeatsRadioButton/MoreSeatsRadioButton";
import SeatsRadioButton from "../SeatsRadioButton/SeatsRadioButton";
import { useTranslation } from "react-i18next";
import classes from "./NewOrderModal.module.scss";

const NewOrderModal = ({ onClosed, onConfirm }) => {
  const { t } = useTranslation();
  const [seats, setSeats] = useState("0");
  const [showMoreSeats, setShowMoreSeats] = useState(false);

  const onChangeSeatsHandler = (newValue) => {
    setSeats(newValue);
  };

  const closeModal = () => {
    setSeats("1-2");
    setShowMoreSeats(false);
    onClosed();
  };

  const selectGroupSize = () => {
    if (seats === ">6") {
      return setShowMoreSeats(true);
    }
    onConfirm(seats);
  };

  return (
    <Modal>
      <div>
        <h3 className={classes.BookingModalHeading}>
          {t("SELECT_NUMBER_OF_GUESTS")}
        </h3>
        {!showMoreSeats && (
          <div className={classes.Seats}>
            <SeatsRadioButton
              defaultChecked
              onChangeSeats={onChangeSeatsHandler}
              text="1-2"
            />
            <SeatsRadioButton onChangeSeats={onChangeSeatsHandler} text="4-6" />
            <SeatsRadioButton onChangeSeats={onChangeSeatsHandler} text=">6" />
          </div>
        )}
        {showMoreSeats && (
          <div className={classes.MoreSeats}>
            <MoreSeatsRadioButton
              onChangeSeats={onChangeSeatsHandler}
              text="6-8"
            />
            <MoreSeatsRadioButton
              onChangeSeats={onChangeSeatsHandler}
              text="8-10"
            />
            <MoreSeatsRadioButton
              onChangeSeats={onChangeSeatsHandler}
              text="10-12"
            />
            <MoreSeatsRadioButton
              onChangeSeats={onChangeSeatsHandler}
              text="12-14"
            />
          </div>
        )}
        <div className={classes.ModalButtons}>
          <button
            className={[classes.ModalButton, classes.ModalSecondaryButton].join(
              " "
            )}
            onClick={closeModal}
          >
            {t("BTN_CANCEL")}
          </button>
          <button
            className={[classes.ModalButton, classes.ModalPrimaryButton].join(
              " "
            )}
            onClick={selectGroupSize}
          >
            {t("BTN_SELECT")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default NewOrderModal;
